import { Chip, CircularProgress } from "@mui/material";

import { SkillAccessibility } from "@/shared/domain/skills";

import {
  ACCESSIBILITY_CHIP_COLOR,
  ACCESSIBILITY_LABEL,
} from "./skillAccessibility";
import styles from "./VisibilityChip.module.css";

interface Props {
  accessibility: SkillAccessibility;
  /** Show a spinner in place of the icon while a tier change is in flight. */
  pending?: boolean;
}

/**
 * The colored visibility chip — shown standalone wherever a skill's tier is
 * read-only (the detail page header, a non-author's list row) and as the
 * collapsed value of the author's accessibility dropdown.
 */
export function VisibilityChip({ accessibility, pending }: Props) {
  return (
    <Chip
      size="small"
      label={ACCESSIBILITY_LABEL[accessibility]}
      color={ACCESSIBILITY_CHIP_COLOR[accessibility]}
      icon={
        pending ? (
          <CircularProgress size={12} className={styles.chipSpinner} />
        ) : undefined
      }
    />
  );
}
